<section class="Upload">
	<!-- Take or Select photos -->
	<section class="Upload__images">
		<!-- Input to select photos -->
		<input
			#selectPhotoInput
			class="Upload__hidden"
			type="file"
			multiple
			accept="image/*;capture=camera"
			(change)="onHandleFiles($event)"
		/>
		<!-- Input to take photos -->
		<input
			#takePhotoInput
			class="Upload__hidden"
			type="file"
			multiple
			accept="image/*;capture=environment"
			(change)="onHandleFiles($event)"
		/>
	</section>

	<!-- Actions -->
	<section
		class="Upload__actions"
		[class.Margin-bottom--s]="
			(isSelectPhotoEnable() || isTakePhotoEnable()) && filesPreview().length
		"
	>
		<app-button
			*ngIf="isSelectPhotoEnable()"
			isFull
			isOutline
			class="Upload__actions__item"
			color="green"
			(clicked)="onSelectPhoto()"
		>
			adjuntar imagen
		</app-button>
		<app-button
			*ngIf="isTakePhotoEnable()"
			isFull
			class="Upload__actions__item"
			color="green"
			(clicked)="onTakePhoto()"
		>
			tomar foto
		</app-button>
	</section>

	<!-- File Preview -->
	<section *ngIf="filesPreview().length" class="Upload__preview">
		<section *ngFor="let filePreview of filesPreview()" class="Upload__preview__item">
			<img [src]="filePreview.preview" [alt]="filePreview.file.name" />
			<section>
				<p>{{ filePreview.file.name }}</p>
				<p class="Color--grayTwo">{{ filePreview.file.size | bytes }}</p>
			</section>
			<app-icon-button
				class="Upload__preview__button"
				buttonSize="medium"
				color="red"
				(clicked)="removeFilePreview(filePreview.file)"
			>
				<app-icon appIcon [icon]="EIcons.xmarkSolid" iconSize="small" [iconMoveTopToBotton]="1" />
			</app-icon-button>
		</section>
	</section>
</section>
